<!--
  - Copyright (c) 2025. Haodong JU
  -->

<template>
  <div>
    <v-tabs
      v-model="tab"
      background-color="transparent"
      color="black"
      style="background: transparent"
    >
      <v-tab>用户画像分析</v-tab>
      <v-tab>消费频率分析</v-tab>
      <v-tab>消费偏好分析</v-tab>
      <v-tab>资产使用分析</v-tab>
      <v-tab>优惠券使用分析</v-tab>

      <v-spacer v-if="showDatePicker" />
      <date-range-picker
        v-if="showDatePicker"
        v-model="dateRange"
        class="mt-2 mr-4"
      />
    </v-tabs>
    <v-divider />
    <v-tabs-items
      v-model="tab"
      class="mt-4"
      style="background: transparent"
    >
      <v-tab-item>
        <user-profile-analysis />
      </v-tab-item>
      <v-tab-item>
        <consumption-frequency-analysis
          :date-range="dateRange"
        />
      </v-tab-item>
      <v-tab-item>
        <consumption-preferences-analysis
          :date-range="dateRange"
        />
      </v-tab-item>
      <v-tab-item>
        <asset-usage-analysis
          :date-range="dateRange"
        />
      </v-tab-item>
      <v-tab-item>
        <coupon-usage-analysis
          :date-range="dateRange"
        />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import UserProfileAnalysis from '@/views/AadenPages/memberShipReborn/userManagement/analysis/UserProfileAnalysis.vue'
import ConsumptionFrequencyAnalysis
  from '@/views/AadenPages/memberShipReborn/userManagement/analysis/ConsumptionFrequencyAnalysis.vue'
import ConsumptionPreferencesAnalysis
  from '@/views/AadenPages/memberShipReborn/userManagement/analysis/ConsumptionPreferencesAnalysis.vue'
import AssetUsageAnalysis from '@/views/AadenPages/memberShipReborn/userManagement/analysis/AssetUsageAnalysis.vue'
import CouponUsageAnalysis from '@/views/AadenPages/memberShipReborn/userManagement/analysis/CouponUsageAnalysis.vue'
import DateRangePicker from '@/views/widget/commonLogic/DateRangePicker.vue'

export default {
  name: 'DataAnalysis',
  components: {
    UserProfileAnalysis,
    ConsumptionFrequencyAnalysis,
    ConsumptionPreferencesAnalysis,
    AssetUsageAnalysis,
    CouponUsageAnalysis,
    DateRangePicker
  },
  data () {
    return {
      tab: 0,
      dateRange: [
        dayjs().subtract(30, 'days').format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD')
      ]
    }
  },
  computed: {
    showDatePicker () {
      // Show date picker for tabs that need date selection
      return this.tab >= 1 // All tabs except the first one need date selection
    }
  }
}
</script>

<style scoped>
</style>
